import { BreadCrumb } from 'primereact/breadcrumb';
import { MenuItem } from 'primereact/menuitem';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledBreadCrumb = styled(BreadCrumb)`
  &.p-breadcrumb {
    margin-bottom: var(--medium-padding);
    border: 0;
    padding: 0;
    font-size: var(--xsmall-font-size);
    line-height: var(--xsmall-line-height);
    flex-shrink: 0;

    &.no-space {
      margin: 0px;
    }

    ol li.p-menuitem-separator {
      padding: 0;
      margin: 0 6px;
      color: var(--gray-dark);
      font-size: var(--small-font-size);
      line-height: var(--xsmall-line-height);

      > svg {
        display: none;
      }

      &::before {
        content: '/';
        display: inline-block;
        color: var(--gray-dark);
        font-weight: 700;
      }
      &:first-of-type {
        display: none;
      }
    }
  }
`;

type AppBreadCrumbProps = {
  model: MenuItem[];
} & React.HTMLAttributes<HTMLElement>;

const AppBreadCrumb: React.FC<AppBreadCrumbProps> = ({ model, ...rest }) => {
  const ref = useRef<BreadCrumb>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (ref.current) {
      const separatorElements = ref.current
        .getElement()
        ?.querySelectorAll('[role="separator"]');

      // Hide the separator elements from screen readers
      separatorElements?.forEach((separator) => {
        separator.setAttribute('aria-hidden', 'true');
      });
    }
  }, [model]);

  return (
    <StyledBreadCrumb
      aria-label={t('generic.breadcrumb')}
      model={model}
      {...rest}
      ref={ref}
      tabIndex={-1}
    />
  );
};

export default AppBreadCrumb;
